import {  put, takeEvery } from "redux-saga/effects";
import {
  GET_TEMP_DATA,
  ADD_PUSH_ITEM,
  UPDATE_PUSH_ITEM,
  DELETE_REMOVE_ITEM,
} from "./actionTypes"

import {
  getTempDataSuccess,
  addPushItemSuccess,
  updatePushItemSuccess,
  deleteRemoveItemSuccess,
  commonFuntionsManagementApiError,
} from "./actions"

function* onGetTempData({ payload: record }) {
  try {
    yield put(getTempDataSuccess(record))
  } catch (error) {
    yield put(commonFuntionsManagementApiError(error))
  }
}


function* onPushItem({ payload: record }) {
  try {
    yield put(addPushItemSuccess(record))
  } catch (error) {
    yield put(commonFuntionsManagementApiError(error))
  }
}

function* onUpdatePushItem({ payload: record }) {
  try {
    //const response = yield call(updateProductDesignCode, record)
    yield put(updatePushItemSuccess(record))
  } catch (error) {
    yield put(commonFuntionsManagementApiError(error))
  }
}

function* onDeleteRemoveItem({ payload: guid }) {
  try {
    yield put(deleteRemoveItemSuccess(guid))
  } catch (error) {
    yield put(commonFuntionsManagementApiError(error))
  }
}

function* transactionRestrictionProfileDetailSaga() {

    yield takeEvery(GET_TEMP_DATA,onGetTempData)
    yield takeEvery(ADD_PUSH_ITEM,onPushItem)
    yield takeEvery(UPDATE_PUSH_ITEM,onUpdatePushItem)
    yield takeEvery(DELETE_REMOVE_ITEM,onDeleteRemoveItem)
}

export default transactionRestrictionProfileDetailSaga
